import React from 'react';

/**
 * Xarı bülbül — Xankəndi kampusunun emblemi.
 *
 * Forma Kompleksin verdiyi təsvirə əsaslanır: dörd ləçək X şəklində
 * açılır, sağ yuxarı ləçəyin yerində yaşıl bülbül dayanır.
 *
 *   variant="color" — tam rəngli emblem (loqo kimi)
 *   variant="mono"  — tək rəng, currentColor (su nişanı və ya ikon)
 */
const PETAL_TOP_LEFT    = 'M0 0Q-12-34-48-36Q-36-6 0 0Z';
const PETAL_BOTTOM_LEFT = 'M0 0Q-38-6-50 30Q-16 16 0 0Z';
const PETAL_BOTTOM_RIGHT= 'M0 0Q2 30 34 44Q24 14 0 0Z';
const BIRD              = 'M0 0Q8-28 28-33Q30-40 36-39Q42-38 48-40Q42-34 37-33Q35-29 32-27Q24-6 0 0Z';

export const KHB_COLORS = {
  magenta: '#A6248C',
  purple:  '#7B2A6E',
  deep:    '#5E1F55',
  green:   '#7CB82F',
};

export default function KhariBulbul({ size = 40, variant = 'color', className = '', style }) {
  const mono = variant === 'mono';
  const c = mono
    ? { magenta: 'currentColor', purple: 'currentColor', deep: 'currentColor', green: 'currentColor' }
    : KHB_COLORS;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size} height={size} viewBox="0 0 120 120"
      className={('khb ' + className).trim()}
      style={style}
      aria-hidden="true"
      focusable="false"
    >
      <g transform="translate(60,58)">
        <path d={PETAL_TOP_LEFT}     fill={c.magenta} />
        <path d={PETAL_BOTTOM_LEFT}  fill={c.purple} />
        <path d={PETAL_BOTTOM_RIGHT} fill={c.deep} />
        <path d={BIRD}               fill={c.green} />
      </g>
    </svg>
  );
}
